<template>
  <div class="record-list-static">
    <div class="record-row">
      <div style="width: 120px;">訪船日</div>
      <div style="width: 80px;">訪船担当者</div>
      <div>メモ</div>
      <span></span>
    </div>
    <template v-for="(record, idx) in localRecords">
      <div class="record-row" :key="record.id || idx" v-if="!record.is_deleted">
        <div class="record-date-box">
          <flat-pickr
            v-model="record.visit_at"
            :config="dateConfig"
            class="record-date"
            placeholder="日付選択"
            @input="$emit('editing')"
          />
          <img
            src="@/assets/images/manning-vessel-crew/calendar.svg"
            alt="Calendar"
            data-toggle
          />
        </div>
        <div style="width: 80px;">
          <span>{{ record.visitor_name }}</span>
        </div>
        <input
          class="record-date-box"
          type="input"
          v-model="record.memo"
          style="min-width: 200px;"
          @input="$emit('editing')"
        />
        <button class="record-delete-btn" @click="removeRecord(idx)">
          <img
            src="@/assets/images/manning-vessel-crew/delete.svg"
            alt="Delete record"
          />
        </button>
      </div>
    </template>
    <div class="record-add-row" @click="addRecord">
      <img src="@/assets/images/manning-vessel-crew/add.svg" alt="Add record" />
      <span>訪船記録を追加</span>
    </div>
    <FormButtonList
      :activeSave="activeSave"
      @save="onSave"
      @cancel="onCancel"
    />
  </div>
</template>
<script>
import EnterpriseManningVesselCrewVisitRecordService from "../../../services/master/EnterpriseManningVesselCrewVisitRecordService";
import FormButtonList from "./FormButtonList.vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Japanese } from "flatpickr/dist/l10n/ja.js";

export default {
  components: { FormButtonList, flatPickr },
  props: {
    records: {
      type: Array,
      default: () => [],
    },
    crewId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      activeSave: true,
      localRecords: [...this.records],
      dateConfig: {
        dateFormat: "Y-m-d",
        allowInput: true,
        locale: Japanese,
        wrap: true,
      },
    };
  },
  watch: {
    localRecords: {
      handler: function() {
        for (const record of this.localRecords) {
          if (!record.visit_at) {
            this.activeSave = false;
            return;
          }
        }
        this.activeSave = true;
      },
      deep: true,
    },

    records: {
      handler(newVal) {
        this.localRecords = [...newVal];
      },
    },
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return "";
      const d = new Date(dateStr);
      return `${d.getFullYear()}/${(d.getMonth() + 1)
        .toString()
        .padStart(2, "0")}/${d
        .getDate()
        .toString()
        .padStart(2, "0")}`;
    },
    addRecord() {
      this.localRecords.push({
        visit_at: "",
        memo: "",
        is_deleted: false,
      });
      this.$emit("editing");

      this.$nextTick(() => {
        window.dispatchEvent(new Event("resize"));
      });
    },
    removeRecord(idx) {
      const record = this.localRecords[idx];
      // idがない場合はローカルリストから削除
      if (!record.id) {
        this.localRecords.splice(idx, 1);
        return;
      }
      this.$set(this.localRecords, idx, {
        ...this.localRecords[idx],
        is_deleted: true,
      });
      this.$emit("editing");
    },
    async onSave() {
      this.$vs.dialog({
        type: "confirm",
        color: "primary",
        title: "保存",
        text: "保存しますか？",
        cancelText: "キャンセル",
        acceptText: "OK",
        accept: async () => {
          try {
            const visits = this.localRecords.map(r => {
              const { ...rest } = r;
              return {
                ...rest,
              };
            });
            const res = await EnterpriseManningVesselCrewVisitRecordService.update(
              this.crewId,
              { visits }
            );
            this.localRecords = res.visits;
            this.$emit("saved");
          } catch (e) {
            this.$emit("save-failed");
          }
        },
        cancel: () => {},
      });
    },
    onCancel() {
      this.$emit("cancel");
    },
  },
};
</script>
<style scoped>
.record-list-static {
  padding: 16px;
  font-size: 12px;
  font-weight: 600;
}

.record-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
  width: 100%;
}

.record-date-box {
  display: flex;
  width: 120px;
  align-items: center;
  background: #fff;
  border: 1px solid #d6dbe1;
  border-radius: 2px;
  padding: 13px 9px;
  gap: 12px;
  justify-content: space-between;
}

.record-date {
  border: none;
  width: 75px;
  padding: unset;
}

.record-select-box {
  display: flex;
  flex: 1;
  align-items: center;
  background: #fff;
  border: 1px solid #d6dbe1;
  border-radius: 2px;
  padding: 13px 9px;
  gap: 12px;
  justify-content: space-between;
}

.record-delete-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #b0b0b0;
  font-size: 20px;
  padding: 0 6px;
}

.record-add-row {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #222;
  margin: 18px 0 18px 0;
  gap: 8px;
  cursor: pointer;
}

.record-add-row .icon-plus {
  font-size: 20px;
  color: #03a9f4;
}

.record-actions {
  display: flex;
  gap: 18px;
  margin-top: 18px;
}
</style>
